import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rotulo-cabecalho',
  templateUrl: './rotulo-cabecalho.component.html',
  styleUrls: ['./rotulo-cabecalho.component.scss']
})
export class RotuloCabecalhoComponent {
  @Input() cliente?: string;
  @Input() contrato?: string;
  @Input() cnpj?: string;
  @Input() tipoDeContrato?: string;
  @Input() mesReferencia?: string;
  @Input() vencimento?: Date;
  @Input() faturaNumero?: string;
  @Input() valor?: number;
  @Input() dataEmissao?: Date;
  @Input() emissao?: Date;
}
